import React from "react";
import { ClipLoader } from "react-spinners";

const CustomLoader = ({ size }) => {
  size = size ? size : 60;
  return <ClipLoader color="#224767" size={size} />;
};

export default CustomLoader;
